<template>
  <ul v-if="value">
    <li v-for="(item, index) in value"
        :key="item.link + index">
      <a :href="item.link">
        {{item.title}}
      </a>
      <site-map-list :value="item.childs"/>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'site-map-list',
    props: {
      value: Array
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
